"use client";

import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/lib/auth/auth-context";
import { getMyBilling } from "@/services/billing";
import { walletBalanceKeys } from "./keys";

export const useWalletBalance = () => {
  const { isAuthenticated } = useAuth();

  const { data, isPending, isError, refetch } = useQuery({
    queryKey: walletBalanceKeys.summary(),
    queryFn: getMyBilling,
    enabled: isAuthenticated,
    staleTime: 30_000,
    retry: false,
  });

  const wallet = data?.wallet ?? null;

  return {
    wallet,
    balance: wallet?.balance ?? 0,
    available: Math.max(0, (wallet?.balance ?? 0) - (wallet?.pending ?? 0)),
    isPending,
    isError,
    refetch,
  };
};
